import { ChangeEventHandler, useEffect, useState } from "react";

import t from "../../i18n";
import Input from "../forms/Input";
import Well from "../ui/Well";

type Props = {
  onChange: (code: string) => void;
  title: string;
  subTitle: string;
  length?: number;
};

export default function DigitAccess({ length, onChange, title, subTitle }: Props) {
  length ??= 6;
  const [sessionCode, setSessionCode] = useState("");

  const onSessionCodeChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const sessionCode = e.target.value.replace(/[^\d]/g, "").slice(0, length);
    setSessionCode(sessionCode);
  };

  useEffect(() => {
    if (sessionCode.length !== length) return;

    onChange(sessionCode);
  }, [sessionCode, onChange, length]);

  return (
    <Well>
      <Well.Title>{title}</Well.Title>
      <p>{subTitle}</p>
      <Well.Footer>
        <Input
          className="text-center text-lg"
          value={sessionCode}
          onChange={onSessionCodeChange}
          placeholder={t("%{length}-digit access code", { length })}
          autoFocus
        />
      </Well.Footer>
    </Well>
  );
}
